<!-- Thank You Page -->
<div class="ty-page">

  <!-- Header Bar -->
  <!-- <div class="ty-header">
    <img src="assets/images/bajaj-capital-logo.png" alt="Bajaj Capital" class="ty-logo"
      onerror="this.style.display='none'" />
    <span class="ty-brand">Bajaj Capital</span>
  </div> -->

  <!-- Main Content -->
  <div class="ty-container">

    <!-- Success Card -->
    <div class="ty-card">

      <!-- Animated Checkmark -->
      <div class="ty-check-wrap">
        <svg class="ty-check-svg" viewBox="0 0 52 52">
          <circle class="ty-check-circle" cx="26" cy="26" r="25" fill="none" />
          <path class="ty-check-tick" fill="none" d="M14 27 l8 8 l16-16" />
        </svg>
      </div>

      <!-- Text -->
      <h1 class="ty-title">Thank You!</h1>
      <p class="ty-subtitle">
        Your details have been submitted successfully.
      </p>
      <p class="ty-note">
        A Bajaj Capital Financial Partner will contact you within the next 24 hours.
      </p>

      <!-- Divider -->
      <div class="ty-divider"></div>

      <!-- Info Chips -->
      <div class="ty-chips">
        <div class="ty-chip">
          <span class="ty-chip-icon">📞</span>
          <span>Expert Call Back</span>
        </div>
        <div class="ty-chip">
          <span class="ty-chip-icon">🔒</span>
          <span>100% Secure</span>
        </div>
        <div class="ty-chip">
          <span class="ty-chip-icon">⚡</span>
          <span>Within 24 Hours</span>
        </div>
      </div>

      <!-- CTA Buttons -->
      <div class="ty-actions">
        <button class="ty-btn-primary" (click)="goBack()">
          Back to Home
        </button>
        <a class="ty-btn-secondary" href="https://www.bajajcapital.com" target="_blank">
          Explore More
        </a>
      </div>

      <!-- Campaign Slot Booking Information -->
      <div class="ty-slot-info" *ngIf="currentConfig.showCalendar && isalreadyBooked">
        <div class="ty-divider"></div>
        <p class="ty-slot-text" *ngIf="isBlocked">
          🗓️ Your appointment is already booked at this date and time:<br>
          <strong>{{appointmentDate}}</strong> at <strong>{{appointmentTime}}</strong>
        </p>
        <p class="ty-slot-text" *ngIf="!isBlocked">
          🗓️ Appointment Confirmed:<br>
          <strong>{{appointmentDate}}</strong> at <strong>{{appointmentTime}}</strong>
        </p>
      </div>
    </div>

    <!-- Calendar Popup Modal Overlay -->
    <div class="calendar-popup-overlay" *ngIf="isCalendarPopupVisible" (click)="closeCalendarPopup()">
      <div class="calendar-popup-content" (click)="$event.stopPropagation()">
        <div class="calendar-popup-header">
          <h3 class="calendar-popup-title">{{ isalreadyBooked ? 'Appointment Confirmed!' : 'Schedule Your Consultation' }}</h3>
          <button type="button" class="close-btn" (click)="closeCalendarPopup()">&times;</button>
        </div>

        <!-- Already Booked View -->
        <div class="calendar-popup-body" *ngIf="isalreadyBooked"> 
          <h4 class="booked-message">
            Your appointment has been fixed. We will call you on 
            <span class="highlight">{{appointmentDate}}</span> at <span class="highlight">{{appointmentTime}}</span>.
          </h4>
        </div>

        <!-- Selection View -->
        <div class="calendar-popup-body" *ngIf="!isalreadyBooked">
          <div class="calendar-selection-wrapper">
            
            <!-- Date Picker Section -->
            <div class="date-selection-section">
              <h4 class="section-title">Select Date</h4>

              <!-- Month/Year Header & Navigation -->
              <div class="calendar-header">
                <div class="calendar-nav">
                  <button type="button" class="nav-btn" (click)="previousMonth()">
                    <i class="fa fa-chevron-left"></i>
                  </button>
                  <span class="current-month-year">{{currentMonth.format('MMMM YYYY')}}</span>
                  <button type="button" class="nav-btn" (click)="nextMonth()">
                    <i class="fa fa-chevron-right"></i>
                  </button>
                </div>
              </div>

              <!-- Calendar Month Grid -->
              <div class="calendar-grid">
                <div class="calendar-weekdays">
                  <div class="weekday" *ngFor="let day of ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']">
                    {{day}}
                  </div>
                </div>

                <div class="calendar-days">
                  <div *ngFor="let day of calendarDays" class="calendar-day" 
                    [class.current-month]="day.isCurrentMonth"
                    [class.other-month]="!day.isCurrentMonth" 
                    [class.today]="day.isToday" 
                    [class.selected]="day.isSelected"
                    [class.disabled]="day.isDisabled" 
                    [class.available]="day.isAvailable"
                    (click)="selectCalendarDate(day)">
                    {{day.date.format('D')}}
                  </div>
                </div>
              </div>

              <!-- Calendar Actions -->
              <div class="calendar-actions">
                <button type="button" class="clear-btn" (click)="clearSelection()">CLEAR</button>
              </div>
            </div>

            <!-- Time Slot Selection Section -->
            <div class="time-selection-section" [class.has-selection]="!!selectedDate" *ngIf="selectedDate">
              <div class="time-selection-header">
                <h4 class="section-title">Select Time Slot</h4>
              </div>
              <div class="time-slots">
                <div *ngFor="let timeSlot of availableTimeSlots" class="time-slot"
                  [class.selected]="selectedTimeSlot === timeSlot" (click)="selectTimeSlot(timeSlot)">
                  {{timeSlot}}
                </div>
              </div>

              <!-- Confirm Button -->
              <div class="popup-actions" *ngIf="isAppointmentReady()">
                <p class="_popmsg">{{popupmessage}}</p>
                <button type="button" class="btn btn-primary confirm-btn" (click)="confirmAppointment()" [disabled]="isButtonDisabled">
                  Confirm Appointment
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- App Store Badges -->
    <div class="ty-app-section">
      <p class="ty-app-text">Also, manage your investments on the go!</p>
      <div class="ty-app-badges">
        <a href="https://apps.apple.com/in/app/ameya/id6741098441" target="_blank" rel="noopener">
          <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
            alt="App Store" class="ty-badge" />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.bajajcapital.investments&hl=en_IN"
          target="_blank" rel="noopener">
          <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
            alt="Google Play" class="ty-badge" />
        </a>
      </div>
    </div>

  </div>

  <!-- Footer Disclaimer -->
  <div class="ty-footer">
    <p>Bajaj Capital Limited (CIN: U67120DL1965PLC004338) | AMFI-registered Mutual Fund Distributor (ARN 0010)</p>
    <p>Mutual Fund investments are subject to market risks. Please read all scheme-related documents carefully.</p>
  </div>

</div>